module.exports = __webpack_public_path__ + "img/Mask Group 4@2x.png";